const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));

export interface IWaitForDomRegistrationOptions {
    intervalMs: number;
    maxAttempts: number;
    signal?: AbortSignal;
}

/**
 * Polls until `predicate` is satisfied or `maxAttempts` is reached (non-throwing).
 */
export async function waitUntil(predicate: () => boolean, { intervalMs, maxAttempts, signal }: IWaitForDomRegistrationOptions): Promise<void> {
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
        if (signal?.aborted) return;
        if (predicate()) return;
        await sleep(intervalMs);
    }
}
